module.exports = __webpack_public_path__ + "img/impact-1.badbf4e8.jpg";